import apiClient from './ApiClient';

export class WorkflowInstanceRepository {
	constructor(client) {
		this.client = client;
		this.basePath = '/api/workflow-instances';
	}

	async listAssignedToMe() {
		return this.client.get(`${this.basePath}/assigned-to-me`);
	}

	async getById(instanceId) {
		return this.client.get(`${this.basePath}/${instanceId}`);
	}
}

export default new WorkflowInstanceRepository(apiClient);
